<template>
  <div>
    <div v-if="user">
      <v-card>
        <v-alert v-model="addOvenAlert" dismissible type="warning">{{ addOvenAlertMessage }}</v-alert>
        <v-card-title>
          <span class="headline">Ajout de four à : {{ user.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                Adresse MAC
                <v-text-field
                  v-model="macAddress"
                  mask="NN:NN:NN:NN:NN:NN"
                  v-on:keyup.enter="addOven()"
                  autofocus
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" flat large @click="$emit('close'); reset()">Annuler</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat large @click="addOven()">Valider</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["user"],
  data: () => ({
    currentValue: null,
    macAddress: null,
    addOvenAlert: false,
    addOvenAlertMessage: null
  }),
  methods: {
    // ajoute un four
    addOven() {
      this.api
        .post("admin/users/" + this.user.id + "/ovens", {
          macAddress: this.macAddress
        })
        .then(res => {
          this.$emit("close");
          this.$emit("reload");
          this.reset();
        })
        .catch(err => {
          this.addOvenAlertMessage = err.message;
          this.addOvenAlert = true;
          console.error(err.message);
        });
    },
    // reset tout
    reset() {
      this.macAddress = null;
      this.addOvenAlert = false;
      this.addOvenAlertMessage = null;
    }
  }
};
</script>
